/* Cookie choices: shows the card where Shopify says consent is needed and records the visitor's answer with Shopify. */
(function () {
  var root = document.getElementById('csConsent');
  if (!root) return;
  var first = root.querySelector('[data-layer="first"]');
  var manage = root.querySelector('[data-layer="manage"]');
  var close = root.querySelector('[data-consent="close"]');
  var switches = Array.prototype.slice.call(root.querySelectorAll('[data-choice]'));
  var api = null, revisit = false, hideTimer, showTimer;

  function layer(name) {
    first.hidden = name !== 'first';
    manage.hidden = name !== 'manage';
    close.hidden = name !== 'manage';
  }
  function open(name, focus) {
    clearTimeout(showTimer);
    clearTimeout(hideTimer);
    layer(name);
    root.hidden = false;
    root.classList.remove('out');
    requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('on'); }); });
    if (focus) root.querySelector(name === 'first' ? '#csTitle' : '#csManageTitle').focus({ preventScroll: true });
  }
  function hide() {
    root.classList.remove('on');
    root.classList.add('out');
    hideTimer = setTimeout(function () { root.hidden = true; root.classList.remove('out'); }, 300);
  }
  function current() {
    var stored = api.currentVisitorConsent();
    return { analytics: stored.analytics === 'yes', marketing: stored.marketing === 'yes', preferences: stored.preferences === 'yes' };
  }
  function hasDecision() {
    var stored = api.currentVisitorConsent();
    return ['analytics', 'marketing', 'preferences'].every(function (key) { return stored[key] === 'yes' || stored[key] === 'no'; });
  }
  function setSwitches(choice) {
    switches.forEach(function (s) { s.setAttribute('aria-checked', String(Boolean(choice[s.dataset.choice]))); });
  }
  function fromSwitches() {
    var choice = {};
    switches.forEach(function (s) { choice[s.dataset.choice] = s.getAttribute('aria-checked') === 'true'; });
    return choice;
  }
  function say(message) { if (window.csToast) window.csToast(message); }
  function save(choice, message) {
    if (!api) return;
    root.setAttribute('aria-busy', 'true');
    api.setTrackingConsent({ analytics: choice.analytics, marketing: choice.marketing, preferences: choice.preferences }, function (response) {
      root.removeAttribute('aria-busy');
      if (response && response.error) { say(root.dataset.failed); return; }
      try { localStorage.setItem('csConsentDecided', '1'); } catch (e) {}
      root.dataset.recordedConsent = JSON.stringify(api.currentVisitorConsent());
      root.dataset.analyticsAllowed = typeof api.analyticsProcessingAllowed === 'function' ? String(api.analyticsProcessingAllowed()) : 'unavailable';
      revisit = true;
      hide();
      say(message);
    });
  }

  root.addEventListener('click', function (event) {
    var control = event.target.closest('[data-consent],[data-choice]');
    if (!control) return;
    if (control.dataset.choice) {
      control.setAttribute('aria-checked', String(control.getAttribute('aria-checked') !== 'true'));
      return;
    }
    var action = control.dataset.consent;
    if (action === 'accept') save({ analytics: true, marketing: true, preferences: true }, root.dataset.savedAccept);
    else if (action === 'reject') save({ analytics: false, marketing: false, preferences: false }, root.dataset.savedReject);
    else if (action === 'save') save(fromSwitches(), root.dataset.savedCustom);
    else if (action === 'manage') { if (api) setSwitches(current()); open('manage', true); }
    else if (action === 'close') { if (revisit) hide(); else open('first', true); }
  });
  root.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' || manage.hidden) return;
    if (revisit) hide(); else open('first', true);
  });
  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-cookie-choices]');
    if (!link || !api) return;
    event.preventDefault();
    revisit = hasDecision();
    setSwitches(current());
    open('manage', true);
  });

  function ready() {
    var native = document.querySelector('script[src*="privacy-banner/storefront-banner"]');
    if (native && !/[?&]cs_consent=test(?:&|$)/.test(location.search)) { root.dataset.consentApi = 'native-banner'; return; }
    api = window.Shopify.customerPrivacy;
    root.dataset.consentApi = 'ready';
    root.dataset.bannerRequired = String(api.shouldShowBanner());
    root.dataset.initialConsent = JSON.stringify(api.currentVisitorConsent());
    root.dataset.hasConsentDecision = String(hasDecision());
    revisit = hasDecision();
    // QA rerun 21 Oct: Back can show a copy of the page from before the choice; trust the choice made in this browser
    var nav = performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null, decided = false;
    try { decided = localStorage.getItem('csConsentDecided') === '1'; } catch (e) {}
    if (!revisit && decided && nav && nav.type === 'back_forward') revisit = true;
    Array.prototype.forEach.call(document.querySelectorAll('[data-cookie-choices]'), function (link) { link.hidden = false; });
    if (api.shouldShowBanner() && !revisit) showTimer = setTimeout(function () { open('first', false); }, 450);
  }
  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    root.dataset.consentApi = 'loading';
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      if (error) root.dataset.consentApi = 'unavailable';
      if (!error && window.Shopify.customerPrivacy) ready();
    });
  } else root.dataset.consentApi = 'missing-loader';
})();
